import { UpdateInternetMessageIdName } from 'owa-mail-compose-action-names';
import { action } from 'satcheljs/lib/legacy';

export default action(UpdateInternetMessageIdName)(function updateInternetMessageIdAction(
    conversationId: string,
    itemId: string,
    internetMessageId: string
) {
    // No-op
    // This is called to raise a stitch set up by owa-mail-reading-pane.
});
